import styled from 'styled-components';
import { Link } from '../../../components/Link/Link';

import heroBgSrc from '../../../assets/images/education/education_index_hero_bg.jpg';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Hero = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 570px;
  background-image: url(${heroBgSrc});
  background-repeat: no-repeat;

  @media (width < 1024px) {
    background-size: cover;
    background-position: center;
  }

  @media (width >= 1024px) and (width < 1590px) {
    background-size: 1590px auto;
    background-position-x: left;
    background-position-y: bottom;
  }

  @media (width >= 1590px) {
    background-size: cover;
    background-position-x: left;
    background-position-y: bottom;
  }
`;

export const ContainerOuter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  @media (max-width: 1023px) {
    padding: 0 24px;
  }

  @media (min-width: 1024px) {
    padding: 0 48px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1304px;

  @media (width < 1024px) {
    padding: 28px 0 40px;
  }

  @media (width >= 1024px) {
    padding: 92px 0 126px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
`;

export const Title = styled.h1`
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
`;

export const Desc = styled.p`
  max-width: 536px;
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
`;

export const CardsGrid = styled.div`
  width: 100%;
  margin-top: 60px;

  @media (width < 640px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    margin-top: 40px;
  }

  @media (width >= 640px) and (width < 1024px) {
    display: grid;
    grid-template-columns: repeat(2, 286px);
    gap: 24px;
    justify-content: center;
    margin-top: 50px;
  }

  @media (width >= 1024px) and (width < 1320px) {
    display: grid;
    grid-template-columns: repeat(2, 390px);
    gap: 24px;
    justify-content: center;
    margin-top: 60px;
  }

  @media (width >= 1320px) {
    display: grid;
    grid-template-columns: repeat(3, 390px);
    gap: 24px;
    justify-content: space-between;
    margin-top: 60px;
  }
`;

export const BrandsGrid = styled.div`
  width: 100%;

  @media (width < 1240px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    max-width: 405px;
    margin: 65px auto 0;
  }

  @media (width >= 1240px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 114px;
  }
`;

export const BrandLink = styled(Link)`
  flex-shrink: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 100%;
  }

  @media (width < 1240px) {
    width: 117px;
  }

  @media (width >= 1240px) {
    width: 135px;
  }
`;
